import { __exports as version } from "../../../../../_virtual/version.js";
var hasRequiredVersion;
function requireVersion() {
  if (hasRequiredVersion) return version;
  hasRequiredVersion = 1;
  Object.defineProperty(version, "__esModule", { value: true });
  version.version = void 0;
  version.version = "1.12.1";
  return version;
}
export {
  requireVersion as __require
};
//# sourceMappingURL=version.js.map
